import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './CellBase.scss';

import CellBase from './CellBase';

import RetinaImage from '../RetinaImage';
import AttachmentGray from './images/attachments-gray.png';
import TextLabel from '../Widgets/Labels/TextLabel';
import { LargeCheckbox } from '../Forms/Checkboxes';

import LockRedIcon from '../Icons/LockRedIcon';
import CircleGreenWithCheckmarkIcon from '../Icons/CircleGreenWithCheckmarkIcon';
import EyeRedIcon from '../Icons/EyeRedIcon';
import CommentsRedIcon from '../Icons/CommentRedIcon';
import highlightText from '../Text/HighlightText';

export default class SnippetCell extends CellBase {
    static displayName = displayName('TableView/SnippetCell');

    static propTypes = {
        ...CellBase.propTypes,
        date: PropTypes.string.isRequired,
        author: PropTypes.string.isRequired,
        subject: PropTypes.string,
        attachmentCount: PropTypes.number.isRequired,
        highlightKeywords: PropTypes.object.isRequired,
        isCheckboxEnabled: PropTypes.bool,
        advancedView: PropTypes.bool,
        isChecked: PropTypes.bool,
        onClickCheckbox: PropTypes.func,
        additionalClasses: PropTypes.string,
    };

    static defaultProps = {
        ...CellBase.defaultProps,
        cellType: 'snippet',
        subject: '',
        advancedView: false,
        isChecked: false,
        isCheckboxEnabled: true,
        additionalClasses: styles['snippet-cell'],
    };

    onClickCheckbox = () => {
        this.props.onClickCheckbox();
    };

    renderCell() {
        const {
            subject,
            date,
            author,
            attachmentCount,
            body,
            isChecked,
            highlightKeywords: {
                author: authorKeywords,
                subject: subjectKeywords,
            },
        } = this.props;

        const authorText =
      Array.isArray(author)
          ? author.map(entry => highlightText(entry, authorKeywords))
          : highlightText(author, authorKeywords);

        let subjectClass = 'snippet-subject';

        if (attachmentCount) {
            subjectClass += '-with-attachment';
        }

        return (
            <div className={styles['snippet-container']}>
                {
                    this.props.advancedView &&
                    <div className={styles['snippet-checkbox-and-icons']}>
                        {
                            this.props.isCheckboxEnabled &&
                            <LargeCheckbox
                                onClick={this.onClickCheckbox}
                                checked={isChecked}
                            />
                        }
                        <data className={styles['cell-icons']}>
                            {this.props.isNeedsReview && <EyeRedIcon />}
                            {this.props.isReviewed && <CircleGreenWithCheckmarkIcon />}
                            {this.props.hasComments && <CommentsRedIcon />}
                            {this.props.isHeld && <LockRedIcon />}
                        </data>
                    </div>
                }
                <div className={styles[`snippet-content${this.props.advancedView ? '-advanced' : ''}`]}>
                    <div className={styles['snippet-header']}>
                        <TextLabel className={styles['snippet-author']} data-cell-key="snippetcell.author" title={author}>
                            {authorText}
                        </TextLabel>
                    </div>
                    <div className={styles[subjectClass]}>
                        {
                            !!attachmentCount &&
                            <RetinaImage className={styles['snippet-attachment']} image={AttachmentGray} />
                        }
                        <TextLabel className={styles['snippet-date']} title={date}>
                            {date}
                        </TextLabel>
                        <TextLabel data-cell-key="snippetcell.subject" title={subject}>
                            {highlightText(subject, subjectKeywords)}
                        </TextLabel>
                    </div>
                    <div>
                        <TextLabel
                            title={body}
                            className={styles['snippet-message-body']}
                        >
                            {highlightText(body, subjectKeywords)}
                        </TextLabel>
                    </div>
                </div>
            </div>
        );
    }
}
